export const factionColor: { [faction: string]: string } = {
  Haruto: "#C101C9",
  Malaya: "#7725CB",
  Einar: "#DB2323",
  Coda: "#177E34",
  Chiara: "#2A46FE"
};
